import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

export default function NotFoundPage() {
  const { t } = useI18n();
  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-4 py-24 text-center">
      <span className="font-display text-7xl font-extrabold text-brand">404</span>
      <h1 className="mt-4 font-display text-2xl font-bold text-ink">{t("page_not_found")}</h1>
      <Link to="/" className="mt-6 rounded-full bg-ink px-6 py-3 text-sm font-semibold text-white">{t("go_home")}</Link>
    </div>
  );
}
